export const getIsSafeUrlPath = (urlPath: string): boolean => {
  // A URL path must not contain a ".", because the final "." in a URL must
  // preceed the top-level domain. This function also does not allow relative
  // paths, so it requires the path to start with a "/".
  if (urlPath.includes('.') || !urlPath.startsWith('/')) {
    return false;
  }

  try {
    new URL(urlPath, `https://example.com`);

    return true;
  } catch (error) {
    // Intentionally empty catch block - just return false below.
  }

  return false;
};
